import {HierarchyNodeType, findLocationEntry} from '@domain/shared'

import {HierarchyNode} from '../types'

export const checkIsArea = (location: string) => location.startsWith('a_')

export const checkIsCountry = (location: string) => location.startsWith('c_')

export const getCountries = (list: string[]) => {
  const countries = list.filter(checkIsCountry)
  return countries
}

export const getAllowedAreas = (list: string[]) => {
  const areas = list.filter(checkIsArea)
  return areas
}

export const hasRegionTypeWithChildren = (node: HierarchyNode) => {
  if (node.type === HierarchyNodeType.Region && node.children?.length) {
    return true
  }
  if (Array.isArray(node.children)) {
    return node.children.some((child) => hasRegionTypeWithChildren(child))
  }
  return false
}

export const getRegionIdList = (locationId: string, hierarchy?: HierarchyNode): string[] =>
  hierarchy
    ? findLocationEntry(hierarchy, locationId)
        ?.children.filter(({isAllowed}) => isAllowed)
        .map(({id}) => id) || []
    : []
